import { GlAvatarLink, GlAvatar, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'PipelineTriggerer',
    components: {
        GlAvatarLink,
        GlAvatar
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        pipeline: {
            type: Object,
            required: true
        }
    },
    computed: {
        user () {
            return this.pipeline.user;
        },
        userPath () {
            return this.user?.path || this.user?.webPath;
        },
        avatarUrl () {
            return this.user?.avatar_url || this.user?.avatarUrl;
        }
    }
};
